import { languageToLocale } from '@becurious/languagetolocale';
import applyTracking from '@becurious/applytracking';

export default class MewsStandalone {
	/**
	 * Constructor
	 *
	 * @param {Object} options Configuration options
	 */
	constructor({ configurationIds, hotelID }) {
		configurationIds ?? (configurationIds = [hotelID]);
		this.standaloneUrl = `https://app.mews.com/distributor/${configurationIds.join(';')}`;
		this.fallbackLanguage = 'en';
	}

	/**
	 * Open the booking engine
	 *
	 * @param {object} options  Options object
	 *
	 * @return {void}
	 */
	visitUrl(options) {
		const url = this.getUrl(options);

		window.open(applyTracking(url));
	}

	/**
	 * Get the standalone booking URL
	 *
	 * @param {object} options Options object
	 *
	 * @return {void}
	 */
	getUrl(options) {
		const url = new URL(this.standaloneUrl);

		const language = languageToLocale(options.language ?? this.fallbackLanguage).replace('_', '-');

		url.searchParams.append('language', language);

		if (options.arrival) {
			url.searchParams.append('mewsStart', options.arrival);
		}

		if (options.departure) {
			url.searchParams.append('mewsEnd', options.departure);
		}

		if (options.promo) {
			url.searchParams.append('mewsVoucherCode', options.promo);
		}

		if (options.arrival && options.departure && options.roomID) {
			url.searchParams.append('mewsRoom', options.roomID);
			url.searchParams.append('mewsRoute', 'rates');
		} else if (options.arrival && options.departure) {
			url.searchParams.append('mewsRoute', 'rooms');
		}

		return url.toString();
	}
}
